import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Link, Typography, Alert } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import moment from 'moment';
import * as authService from '../services/auth';
import * as uiPersistedActions from '../actions/uiPersisted';
import { Colors } from '../assets/theme/Colors';
import useHasActiveFeatureFlag from '../hooks/useFeatureFlags';
import { FF_ANNUAL_APPEAL } from './FeatureFlagWrapper';

const AnnualAppearBanner = () => {
  const user = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const isDrawerOpen = useSelector((state) => state.ui.persisted.isDrawerOpen);
  const dispatch = useDispatch();
  const hideAnnualAppearBanner = useSelector((state) => state.ui.persisted.hideAnnualAppearBanner);
  const hasActiveAnnualAppearFeatureFlag = useHasActiveFeatureFlag(FF_ANNUAL_APPEAL);

  if (!hasActiveAnnualAppearFeatureFlag) {
    return null;
  }

  if (hideAnnualAppearBanner && moment().isBefore(moment(hideAnnualAppearBanner).add(1, 'days'))) {
    return null;
  }

  const onDismiss = () => {
    dispatch(uiPersistedActions.hideAnnualAppearBanner());
  };

  const paddingLeftValueAboveSmBreakpoint = (() => {
    if (user && !authService.shouldHideMainDrawer(user)) {
      return isDrawerOpen ? '250px' : '86px';
    }

    return '16px';
  })();

  return (
    <Alert severity="info" 
    sx={{
        position: 'relative',
        paddingLeft: {
          xs: '6px',
          sm: paddingLeftValueAboveSmBreakpoint,
        },
      }}
    >
      <Typography variant="body2" sx={{ mr: '30px' }}>
        This holiday season, we're on a mission to deliver 6 million meals to those in need. But we can't do it without
        you!{' '}
        <Link
          sx={{ display: 'inline-block' }}
          href="https://secure.qgiv.com/for/foodrescueusmain3"
          target="_blank"
          underline="always"
        >
          Click here
        </Link>{' '}
        to join us in the fight against hunger and food waste.⁠
      </Typography>
      <IconButton
        sx={{ color: Colors.primaryColor, position: 'absolute', top: '6px', right: '24px' }}
        size="small"
        onClick={onDismiss}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Alert>
  );
};

export default AnnualAppearBanner;
